import { formatLanguages, formatShelterDetailsAddress, useRouter } from '@application/utils';
import type { ShelterGetShelterQuery } from '@gql/graphql';
import { useTranslation } from '@presentation/utils';
import { useCallback } from 'react';

export const useFormatShelter = () => {
  const { translate } = useTranslation();
  const { language } = useRouter();

  const formatShelter = useCallback(
    (shelter: NonNullable<ShelterGetShelterQuery['findManyDogShelter']>[number] | undefined) => {
      if (!shelter) {
        return;
      }

      const getWebsiteLink = (
        links: (
          | NonNullable<
              NonNullable<ShelterGetShelterQuery['findManyDogShelter']>[number]['links']
            >[number]
          | null
        )[],
      ): string | null => {
        let item = links.find((x) => x?.name === 'Website');
        if (item && item.link) return item.link;

        item = links.find((x) => x?.name === 'Adopteer');
        if (item && item.link) return item.link;

        item = links.find((x) => x?.name === 'Jadopte');
        if (item && item.link) return item.link;

        item = links.find((x) => x?.name === 'Facebook');
        if (item && item.link) return item.link;

        return links[0]?.link ?? null;
      };

      const translation = shelter.translations.find((x) => x.language === language);

      const formattedAddress = formatShelterDetailsAddress({ ...shelter.address }, translate);

      return {
        name: shelter?.name ?? '-',
        text: translate('shelterDetails.description')
          .replaceAll('$name', shelter?.name ?? '')
          .replaceAll('$location', shelter.address?.city ?? ''),
        description: translation?.description,
        additionalInfo: translation?.additionalInfo,
        email: shelter.emails?.join(', '),
        phoneNumber: shelter.phoneNumbers?.join(', '),
        website: shelter.links ? getWebsiteLink(shelter.links) : null,
        address: shelter.address,
        formattedAddress,
        agreement: shelter.agreementNumber ?? '-',
        spokenLanguages: formatLanguages(language, shelter.spokenLanguages),
      };
    },
    [language, translate],
  );

  return { formatShelter };
};
